import React, { Suspense } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Box, CircularProgress } from '@mui/material';
import { hasPermission } from '../utils/permissions';
import Unauthorized from '../views/pages/Unauthorized';
import routes from '../routes';

const AppContent = () => {
  const { permissions } = useSelector((state) => state.auth);

  return (
    <Box
      component="main"
      id="main-content"
      sx={{
        flexGrow: 1,
        p: { xs: 2, sm: 3 },
        width: '100%',
      }}
    >
      <Suspense
        fallback={
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
            <CircularProgress color="primary" />
          </Box>
        }
      >
        <Routes>
          {routes.map((route, idx) => {
            let hasRequiredPermission = true;
            if (route.requirePermission) {
              if (Array.isArray(route.requirePermission)) {
                hasRequiredPermission = route.requirePermission.some((perm) =>
                  hasPermission(permissions, perm),
                );
              } else {
                hasRequiredPermission = hasPermission(permissions, route.requirePermission);
              }
            }

            return (
              route.element && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  element={
                    route.requirePermission && !hasRequiredPermission ? (
                      <Unauthorized />
                    ) : (
                      <route.element />
                    )
                  }
                />
              )
            );
          })}
          <Route path="/" element={<Navigate to="dashboard" replace />} />
        </Routes>
      </Suspense>
    </Box>
  );
};

export default React.memo(AppContent);
